import { render } from "./not-delivered-order-status.vue?vue&type=template&id=95cb0456"
import script from "./not-delivered-order-status.vue?vue&type=script&lang=js"
export * from "./not-delivered-order-status.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__